<div *ngIf="question">
  <lms-toolbar>
    <div class="lms-toolbar__item">
      <gl-button
        icon
        icon-center="glicon-circle-check"
        (onClick)="certifyQuestion()"
        title="{{ 'customizations.documents.questions.certify' | translate }}"
      ></gl-button>
      <gl-button
        icon
        icon-center="glicon-publish"
        (onClick)="publishQuestion()"
        title="{{ 'customizations.documents.questions.publish' | translate }}"
      ></gl-button>
      <gl-button
        icon
        icon-center="glicon-close"
        (onClick)="cancelQuestion()"
        title="{{ 'customizations.documents.questions.cancel' | translate }}"
      ></gl-button>
      <gl-button
        icon
        icon-center="glicon-trash"
        (onClick)="deleteQuestion()"
        title="{{ 'customizations.documents.questions.delete' | translate }}"
      ></gl-button>
    </div>
  </lms-toolbar>
  <div class="heading-section">{{ 'customizations.documents.questions.detail.title' | translate }}</div>
  <div class="col s12">
    <lms-group-question-editor [question]="question" (onSave)="onUpdateQuestion($event)"> </lms-group-question-editor>
  </div>
</div>
